<div class="container">
  <div class="row">
    <div class="col-lg-7 col-12 mt-4">
      <h4 class="text-white fw-bold summary-title">{{ 'cart.itemsSummary' | translate }}</h4>
      <div class="mb-4 mt-4">
        <fgbcl-cart-item [isCheckoutPage]="true"></fgbcl-cart-item>
      </div>
      <button class="btn fw-bold ps-0 go-back-btn" (click)="goBack()">
        <span class="font-size-14 text-go-back text-white">{{ 'cart.goBack' | translate }}</span>
      </button>
    </div>
    <div class="col-lg-5 col-12 mt-4">
      <!--member details address-->
      <div class="container address-container py-2 mb-3" [ngClass]="{ 'd-none': editingMemberAddress }">
        <div class="position-relative rounded p-1">
          <div class="d-flex justify-content-between">
            <h4 class="text-white font-size-14">{{ 'billing.address.heading' | translate }}</h4>
            <h4 class="cursor-pointer font-size-14 edit-btn fw-bold" (click)="editMemberAddress()">
              {{ 'billing.address.edit' | translate }}
            </h4>
          </div>
          <span *ngIf="memberDetail$ | async as member" class="font-size-12 mb-0 d-flex text-white praktika-medium">
            <div>{{ member.Street }},&nbsp;</div>
            <div>{{ member.Town }},&nbsp;</div>
            <div>{{ member.County }},&nbsp;</div>
            <div>{{ member.Country }},&nbsp;</div>
            <div>{{ member.PostCode }},&nbsp;</div>
            <div>{{ member.HomeNumber }}</div>
          </span>
        </div>
      </div>
      <!--EO member details address view-->

      <!-- EDIT MEMBER DETAILS ADDRESS FORM -->
      <ng-container *ngIf="editingMemberAddress">
        <div class="container address-container mb-3">
          <div class="position-relative p-2">
            <div class="d-flex justify-content-between">
              <h4 class="text-white font-size-14 pt-2 mb-3">{{ 'cart.address.label' | translate }}</h4>
              <a
                (click)="clearAddressForm(memberAddressForm)"
                class="text-white heading-text-one mb-1 pt-2 font-size-14 cursor-pointer font-praktika-bold"
                >{{ 'cart.edit.address.clear.form' | translate }}</a
              >
            </div>

            <form [formGroup]="memberAddressForm" class="font-size-12">
              <!--Street-->
              <div class="form-group form-floating mb-4">
                <input
                  id="Street"
                  class="form-control"
                  name="Street"
                  type="text"
                  formControlName="Street"
                  [ngClass]="{
                    'is-invalid': hasSubmittedMemberAddress && !!memberAddressForm.controls.Street.errors,
                  }"
                  required
                />
                <label for="Street">
                  <span>{{ 'cart.street.label' | translate }}</span>
                </label>
                <div class="invalid-feedback">{{ 'cart.address.street.not.valid' | translate }}</div>
              </div>
              <!--City-->
              <div class="form-group form-floating mb-4">
                <input
                  id="Town"
                  class="form-control"
                  name="Town"
                  type="text"
                  formControlName="Town"
                  [ngClass]="{
                    'is-invalid': hasSubmittedMemberAddress && !!memberAddressForm.controls.Town.errors,
                  }"
                  required
                />
                <label for="Town">
                  <span>{{ 'cart.city.label' | translate }}</span>
                </label>
                <div class="invalid-feedback">{{ 'cart.address.city.not.valid' | translate }}</div>
              </div>
              <!--Country and region-->
              <fgbcl-country-and-regions
                [SeparateRow]="true"
                [Form]="memberAddressForm"
                [HasSubmitted]="hasSubmittedMemberAddress"
              ></fgbcl-country-and-regions>
              <!--Zip code-->
              <div class="form-group form-floating mb-4">
                <input
                  id="Postcode"
                  class="form-control"
                  name="Postcode"
                  type="text"
                  formControlName="PostCode"
                  [ngClass]="{
                    'is-invalid': hasSubmittedMemberAddress && !!memberAddressForm.controls.PostCode.errors,
                  }"
                  required
                />
                <label for="Postcode">
                  <span>{{ 'cart.postcode.label' | translate }}</span>
                </label>
                <div class="invalid-feedback">{{ 'cart.address.postcode.not.valid' | translate }}</div>
              </div>
              <!--Phone-->
              <div class="form-group form-floating mb-4">
                <input
                  id="HomeNumber"
                  class="form-control"
                  name="HomeNumber"
                  type="text"
                  formControlName="HomeNumber"
                  [ngClass]="{
                    'is-invalid': hasSubmittedMemberAddress && !!memberAddressForm.controls.HomeNumber.errors,
                  }"
                  required
                  onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                  minlength="8"
                  maxlength="11"
                />
                <label for="HomeNumber">
                  <span>{{ 'cart.home.number.label' | translate }}</span>
                </label>
                <div class="invalid-feedback">{{ 'cart.address.home.number.not.valid' | translate }}</div>
              </div>
            </form>

            <div class="d-flex justify-content-between my-2 mt-3 font-size-14">
              <button class="btn fw-bold btn-cancel-save me-2 font-size-14" (click)="cancelAndRebuildForm()">
                {{ 'cart.edit.address.cancel' | translate }}
              </button>
              <button class="btn btn-success fw-bold btn-save font-size-14" (click)="saveMemberDetailAddress()">
                {{ 'cart.edit.address.save' | translate }}
              </button>
            </div>
          </div>
        </div>
      </ng-container>
      <!--EO edit member details address-->
      <!--summary of items in basket-->
      <ng-container *ngIf="!editingMemberAddress">
        <div class="container address-container p-3">
          <h4 class="text-white fw-bold font-size-14">{{ 'cart.summary' | translate }}</h4>
          <div class="row praktika-medium">
            <div class="col-6 fw-bold font-size-14">
              <span class="fw-normal">{{ 'cart.summary.items' | translate }}</span>
            </div>
            <ng-container *ngIf="isListHasMerchantItem">
              <div class="col-6 font-size-14 text-end pr-4">{{ totalPriceMerchantValue / 100 | FortressCurrencyPipe }}</div>
            </ng-container>
            <ng-container *ngIf="!isListHasMerchantItem">
              <div class="col-6 font-size-14 text-end pr-4">{{ totalPoints | FortressCurrencyPipe: 'PTS' }}</div>
            </ng-container>
          </div>
          <hr class="w-100" />
          <div class="d-flex justify-content-between align-items-center">
            <ng-container *ngIf="isListHasMerchantItem">
              <div class="fw-bold font-size-14">{{ 'cart.summary.totalMerchant' | translate }}</div>
              <div class="d-flex align-items-center">
                <div class="col-6 fw-bold font-size-14 text-end">{{ totalPriceMerchantValue / 100 | FortressCurrencyPipe }}</div>
              </div>
            </ng-container>
            <ng-container *ngIf="!isListHasMerchantItem">
              <div class="fw-bold font-size-12">{{ 'cart.summary.totalPoint' | translate }}</div>
              <div class="col-6 fw-bold font-size-14 text-end">{{ totalPoints | FortressCurrencyPipe: 'PTS' }}</div>
            </ng-container>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="!editingMemberAddress">
        <div class="payment-type-container" *ngIf="items$ | async as items">
          <h4 class="text-white fw-bold font-size-14">{{ 'cart.payment' | translate }}</h4>
          <ng-container *ngIf="cardInfor.CardNumber; else noCard">
            <div class="card-infor">
              <p class="font-size-14 mb-0">
                {{ 'cart.card.info' | translate }}
                <span class="card-number">({{ cardInfor.CardNumber | creditCardNumber: 'true' }})</span>
              </p>
              <img alt="" class="card-type-image" src="{{ cardInfor.CardType | cardTypeImageUrl }}" /><span
                class="font-size-14 text-white ms-2"
                >Exp:{{ cardInfor.ExpiryDate | date: 'MM/YY' }}</span
              >
            </div>
            <div class="px-0 mt-2">
              <button
                class="btn btn-success fw-bold mt-2 w-100 paynow-btn d-flex justify-content-center"
                (click)="payNow()"
                [disabled]="
                  !memberAddressForm?.valid || !validCheckout || totalPoints > currentBalance || !cardInfor.CardNumber || loading
                "
              >
                {{ statusText }}
                <div *ngIf="loading" class="ms-2">
                  <fgbcl-loading></fgbcl-loading>
                </div>
              </button>
              <div class="separator pt-3">
                <span class="mx-2 seperator-text">{{ 'cart.seperator' | translate }}</span>
              </div>
              <button
                (click)="openCartAddPaymentDetailModal(true)"
                [disabled]="loading || !memberAddressForm?.valid"
                class="btn btn-default text-white fw-bold mt-3 w-100 addcard-btn"
              >
                {{ 'cart.add.new.payment.method' | translate }}
              </button>
            </div>
          </ng-container>
          <ng-template #noCard>
            <button
              class="btn btn-default fw-bold mt-2 w-100 addcard-btn"
              (click)="openCartAddPaymentDetailModal(saveAsCardToken)"
              [disabled]="!memberAddressForm?.valid"
            >
              {{ 'cart.add_new_card' | translate }}
            </button>
          </ng-template>
        </div>
      </ng-container>
      <fgbcl-errors *ngIf="!editingMemberAddress"></fgbcl-errors>
    </div>
  </div>
</div>
